import { type useFormik, type FormikValues } from 'formik';
import { type PublicationPayload } from '../../../graphql/ApplicationForm/publication/types';

export type PublicationBoxData = {
  type: string;
  other_type: string;
  name: string;
  title: string;
  author: string;
  role: string;
  role_other: string;
  status: string;
  date?: string | null;
  issue: string;
  reviewed: string;
  citation: string;
  url: string;
};

export enum ApplicantPublicationRole {
  FIRST_AUTHOR = 'FIRST_AUTHOR',
  SECOND_AUTHOR = 'SECOND_AUTHOR',
  CORRESPONDING_AUTHOR = 'CORRESPONDING_AUTHOR',
  OTHER = 'OTHER',
}

export enum PublicationTypes {
  JOURNAL_ARTICLE = 'JOURNAL_ARTICLE',
  CONFERENCE_PRESENTATION = 'CONFERENCE_PRESENTATION',
  CONFERENCE_PUBLICATION = 'CONFERENCE_PUBLICATION',
  BOOK_CHAPTER = 'BOOK_CHAPTER',
  PROFESSIONAL_MAGAZINE = 'PROFESSIONAL_MAGAZINE',
  NEWSPAPER = 'NEWSPAPER',
  EXHIBITION = 'EXHIBITION', // is not paper
  PATENTS = 'PATENTS',
  OTHER_PUBLICATION = 'OTHER_PUBLICATION',
}

export enum PublicationStatus {
  PUBLISHED = 'PUBLISHED',
  IN_PRESS = 'IN_PRESS',
  UNDER_REVIEW = 'UNDER_REVIEW',
  WRITING_IN_PROGRESS = 'WRITING_IN_PROGRESS',
}

export type PublicationFormValues = Omit<
  PublicationPayload,
  'supportingDocuments'
>;

export type Formik<T extends FormikValues> = ReturnType<typeof useFormik<T>>;
export type FormikProp = Formik<PublicationFormValues>;
